var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"img-fluid mb-3 d-none d-md-block pg-img",attrs:{"src":_vm.imgsrc,"alt":""}}),_c('h1',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.heading))]),_c('p',{staticClass:"font-italic mb-0",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }